// extracted by mini-css-extract-plugin
export var details = "_m4-0";
export var inspectorPopover = "_m4-1";